import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store/store';
import {  InventoryMovementFilter } from '../../types/inventory/InventoryMovementTypes';
import InventoryMovementService from '../../services/inventory/InventoryMovementService.ts'; // ✅ Importar el servicio
import useAlerts from '../useAlerts';
import useLoading from '../useLoading';
import useApiErrorHandler from '../useApiErrorHandler';
import { 
    setIsLoadingMovements, 
    clearMovementList, 
    setMovementList 
} from '../../store/slices/inventory/inventoryMovementSlice';

/**
 * Hook para manejar lógica de movimientos de inventario.
 */
export const useInventoryMovement = () => {
    const dispatch: AppDispatch = useDispatch();
    const { show: showAlert } = useAlerts();
    const { showLoadingIndicator, hideLoadingIndicator } = useLoading();
    const { handle } = useApiErrorHandler();

    const { list, paginator, isLoading } = useSelector(
        (state: RootState) => state.inventoryMovement
    );

    /**
     * Carga los movimientos filtrados con paginación.
     */
    const handlerGetFilteredMovements = async (
        filters: InventoryMovementFilter,
        page = 0,
        size = 10,
        sort = 'movementDate,desc' // 🔥 Por defecto mostrar los más recientes primero
    ) => {
        try {
            dispatch(setIsLoadingMovements(true));
            showLoadingIndicator();

            const response = await InventoryMovementService.getFiltered(filters, page, size, sort);

            dispatch(setMovementList({ content: response.content, paginator: response }));
        } catch (error) {
            handle(error);
            showAlert('error', 'Error', 'No se pudieron obtener los movimientos de inventario.');
        } finally {
            dispatch(setIsLoadingMovements(false));
            hideLoadingIndicator();
        }
    };

    /**
     * Limpia la lista de movimientos y resetea el paginador.
     */
    const handlerClearFilteredMovements = () => {
        dispatch(clearMovementList());
    };

    return {
        list,
        paginator,
        isLoading,
        handlerGetFilteredMovements,
        handlerClearFilteredMovements,
    };
};
